import { SubscriptionStatus } from "@/models/subscriptionStatus";

export default class Subscription {
  constructor(data: {
    dateCreated: string;
    cancelUrl: string;
    cancellationEffectiveDate: string;
    updateUrl: string;
    subscriptionId: string;
    nextBillDate: string;
    status: SubscriptionStatus;
    unitPrice: string;
    currency: string;
  }) {
    this.setData(data);
  }

  setData(data: {
    dateCreated: string;
    cancelUrl: string;
    cancellationEffectiveDate: string;
    updateUrl: string;
    subscriptionId: string;
    nextBillDate: string;
    status: SubscriptionStatus;
    unitPrice: string;
    currency: string;
  }) {
    if (data.dateCreated) {
      this.dateCreated = data.dateCreated;
    }

    if (data.cancelUrl) {
      this.cancelUrl = data.cancelUrl;
    }

    if (data.cancellationEffectiveDate) {
      this.cancellationEffectiveDate = data.cancellationEffectiveDate;
    }

    if (data.updateUrl) {
      this.updateUrl = data.updateUrl;
    }

    if (data.subscriptionId) {
      this.subscriptionId = data.subscriptionId;
    }

    if (data.nextBillDate) {
      this.nextBillDate = data.nextBillDate;
    }

    if (data.status) {
      this.status = data.status;
    }

    if (data.currency) {
      this.currency = data.currency;
    }

    if (data.unitPrice) {
      this.unitPrice = data.unitPrice;
    }
  }

  subscriptionId = "";
  dateCreated = "";
  cancelUrl = "";
  cancellationEffectiveDate = "";
  updateUrl = "";
  nextBillDate = "";
  status = SubscriptionStatus.None;
  currency = "";
  unitPrice = "";
}
